import script from "./FriendDialogItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendDialogItem.vue?vue&type=script&setup=true&lang=js"

import "./FriendDialogItem.vue?vue&type=style&index=0&id=7712a2e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7712a2e2"]])

export default __exports__